import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { PermisiuniComponent } from './permisiuni.component';
import { AddPermisiuneComponent } from './add-permisiune/add-permisiune.component';
import { EditPermisiuneComponent } from './edit-permisiune/edit-permisiune.component';

@NgModule({
  declarations: [
    PermisiuniComponent,
    AddPermisiuneComponent,
    EditPermisiuneComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MaterialModule],
  exports: [PermisiuniComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PermisiuniModule {}
